import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, BriefcaseIcon, LinkedinIcon, BuildingIcon, MapPinIcon, DollarSignIcon, CpuIcon } from 'lucide-react';
export function DatabaseFields() {
  return <section className="py-24 bg-slate-50" data-id="element-3867">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3868">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3869">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-3870">
            Comprehensive{' '}
            <span className="text-blue-600" data-id="element-3871">local business listings</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-3872">
            Our local business database provides deep employee-level data, so
            you can reach the exact decision maker with verified business owner
            emails every time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3873">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3874">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3875">
              <UserIcon className="w-6 h-6" data-id="element-3876" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3877">
              Owner names
            </h3>
            <p className="text-slate-600" data-id="element-3878">
              First and last names of local business owners, founders, and
              managers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3879">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3880">
              <MailIcon className="w-6 h-6" data-id="element-3881" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3882">
              Business owner emails
            </h3>
            <p className="text-slate-600" data-id="element-3883">
              Direct business owner emails and employee lists, verified in
              real-time.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3884">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3885">
              <BriefcaseIcon className="w-6 h-6" data-id="element-3886" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3887">
              Job titles
            </h3>
            <p className="text-slate-600" data-id="element-3888">
              Filter by Owner, Founder, GM, Marketing Director, etc.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3889">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3890">
              <PhoneIcon className="w-6 h-6" data-id="element-3891" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3892">
              Direct phones
            </h3>
            <p className="text-slate-600" data-id="element-3893">
              Mobile and direct dial numbers for key decision makers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3894">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3895">
              <LinkedinIcon className="w-6 h-6" data-id="element-3896" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3897">
              Social profiles
            </h3>
            <p className="text-slate-600" data-id="element-3898">
              LinkedIn profiles for employees and the company.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3899">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3900">
              <BuildingIcon className="w-6 h-6" data-id="element-3901" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3902">
              Firmographics
            </h3>
            <p className="text-slate-600" data-id="element-3903">
              Company size, employee count, and founding year.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3904">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3905">
              <MapPinIcon className="w-6 h-6" data-id="element-3906" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3907">
              Location data
            </h3>
            <p className="text-slate-600" data-id="element-3908">
              Precise HQ addresses and multi-location branch data.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3909">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3910">
              <DollarSignIcon className="w-6 h-6" data-id="element-3911" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3912">
              Revenue estimates
            </h3>
            <p className="text-slate-600" data-id="element-3913">
              Estimated annual revenue to qualify your local business leads.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3914">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3915">
              <CpuIcon className="w-6 h-6" data-id="element-3916" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3917">
              Tech stack
            </h3>
            <p className="text-slate-600" data-id="element-3918">
              Technologies used by the business (Shopify, Toast, etc).
            </p>
          </div>
        </div>
      </div>
    </section>;
}